<template>
    <div
        style="position: relative"
        :style="multiple ? 'margin-left: 3px;' : ''"
        :class="[disabled ? 'disabled-avatar' : '', itemClass]"
    >
        <template v-if="multiple">
            <v-avatar
                :style="{ 'borderRadius': tile ? '4px' : '' }"
                style="position:absolute; left: -3px; opacity: .4;"
                :color="avatar_background"
                :size="size"
                :tile="tile"
            >
            </v-avatar>
            <v-avatar
                :style="{ 'borderRadius': tile ? '4px' : '' }"
                style="position:absolute; left: -6px; opacity: .4;"
                :color="avatar_background"
                :size="size"
                :tile="tile"
            >
            </v-avatar>
        </template>
        <v-avatar
            :color="avatar_background"
            :size="size"
            class="avatar"
            :tile="tile"
            :style="{
                'borderRadius': tile ? '4px' : '',
                'border': inverted ? '1px solid ' + (colors[color] ? colors[color] : color) + ' !important' : '',
            }"
        >
            <img
                v-if="img_url"
                :style="inverted ? 'transform: scale(0.8)' : ''"
                :alt="initials"
                :src="img_url.indexOf('://') === -1 ? base_url + img_url : img_url"
            />

            <span
                v-else-if="!edit && initials"

                :class="[
                    inverted ? color + '--text' : textColor + '--text',
                    textClass,
                    initials.length > 2 ? 'text-ten' : '',
                    inverted ? 'inverted' : 'not-inverted'
                ]"
                :style="inverted ? 'color: ' + color + ';' : ''"
            >
                {{ initials }}
            </span>
            <div
                v-if="edit && img_url"
                class="remove d-flex justify-center align-center"
                :style="'width:' + size + 'px; height:' + size + 'px;'"
                @click="onRemoveClick"
            >
                <div>
                    <icon color="white" :icon="!replaceOnClick ? 'Trash' : 'ImagePlus'" />
                </div>
            </div>
            <div
                v-if="edit && (!img_url || removed)"
                class="add"
                :style="'width:' + size + 'px; height:' + size + 'px;'"
                @click="addFiles"
            >
                <div>
                    <icon icon="Camera" color="n3" large />
                </div>
                <div
                    class="n3--text caption font-weight-medium mx-4"
                    style="line-height: normal"
                >{{ $t('Add your photo') }}</div>
            </div>
            <div style="display:none;">
                <input
                    ref="avatar_upload"
                    type="file"
                    @change="uploadAvatar($event.target.name, $event.target.files)"
                />
                <input id="avatar_data" type="hidden" value="" />
            </div>
        </v-avatar>
    </div>
</template>

<script>
import { $t } from "@/i18n";
import { profile_avatar } from "../api";
import { computed, toRefs, reactive, ref } from "@vue/composition-api";
import colors from "../composables/use-avatar-colors";
import DialogModule from "../store/modules/dialog";

export default {
    name: "AccountAvatar",
    props: {
        multiple: {
            type: Boolean
        },
        account: {
            type: Object,
            default: () => {
            }
        },
        size: {
            type: [String, Number],
            default: 40
        },
        color: {
            type: String,
            default: "primary"
        },
        tile: {
            type: Boolean,
            default: false
        },
        initials: {
            type: String,
            default: ""
        },
        imagePath: {
            type: String,
            default: ""
        },
        inverted: {
            type: Boolean,
            default: false
        },
        itemClass: {
            type: String,
            default: null
        },
        textClass: {
            type: String,
            default: "font-weight-bold subtitle-2"
        },
        textColor: {
            type: String,
            default: "white"
        },
        edit: {
            type: Boolean,
            default: false
        },
        replaceOnClick: {
            type: Boolean
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    setup(props, ctx) {
        const protocol = process.env.VUE_APP_PROTOCOL ? process.env.VUE_APP_PROTOCOL : "";
        const host = process.env.VUE_APP_HOST ? process.env.VUE_APP_HOST : "";
        const base_url = `${protocol}://${host}`;

        const { openConfirmDialog, openError, setConfirmOptions, setErrorOptions } = DialogModule();
        const avatar_upload = ref(null);

        const addFiles = () => {
            avatar_upload.value.click();
        };
        const state = reactive({
            temp_url: null,
            removed: false
        });
        const avatar_background = computed(() => {
            if (props.edit) return "grey lighten-2";
            if (props.inverted) return "white";
            return props.color;
        });
        const check_file = file => {
            const errors = [];

            let ext = file.name.split(".").pop();
            if (file.name === ext) {
                errors.push($t("Adding file failed") + "{0}" + $t("Please check the file.").format(file.name));
            } else {
                ext = ext.toLowerCase();
                if (!["jpg", "jpeg", "png", "gif"].includes(ext)) {
                    errors.push($t("You can only add pictures."));
                }
            }

            return errors;
        };
        const uploadAvatar = async (target_name, files) => {
            if (!files || files.length === 0) {
                return;
            }

            const file = files[0];
            const errors = check_file(file);
            if (errors.length > 0) {
                const error = {
                    title: $t("Error"),
                    text: errors[0]
                };
                setErrorOptions(error);
                openError();
                //handle system error
                // info_box.handle_system_error(errors[0], {
                //     btn_text: "OK",
                //     hide_cancel_button: true
                // });
                // return;
                // TODO
                console.error("todo :: handle avatar upload error", errors);
            }
            try {
                const response = await profile_avatar.post(file, file.name);
                state.temp_url = response.thumbnail_url;
                state.removed = false;
                ctx.emit("changed", response);
            } catch (err) {
                // return info_box.handle_error_response(xhr, xhr.status, xhr.statusText);
            }
        };

        const img_url = computed(() => {
            if (state.temp_url) {
                return state.temp_url;
            }
            if (!state.removed) {
                return props.imagePath;
            }
            return null;
        });
        const onDeleteConfirm = () => {
            state.temp_url = null;
            state.removed = true;
            ctx.emit("changed", { delete: true });
            // return (this.confirm_dialog = false);
        };
        const onRemoveClick = () => {
            if (props.replaceOnClick) {
                addFiles();
            } else {
                setConfirmOptions({
                    title: $t("Notice!"),
                    text: $t("Are you sure that you want to delete this?"),
                    confirm_text: $t("Confirm"),
                    cancel_text: $t("Cancel"),
                    action: onDeleteConfirm
                });
                openConfirmDialog();
            }
        };
        return {
            ...toRefs(state),
            base_url,
            colors,
            avatar_background,
            img_url,
            avatar_upload,
            addFiles,
            uploadAvatar,
            onRemoveClick
        };
    }
};
</script>

<style lang="scss" scoped>
.disabled-avatar {
    pointer-events: none;
    opacity: 0.4;
}

.text-ten {
    font-size: 10px;
}

.remove {
    visibility: hidden;
    position: absolute;
    top: 0;
    left: 0;
    vertical-align: center;
    background: rgba(66, 66, 66, 0.7);
    border-radius: 50%;
    cursor: pointer;
}

.add {
    position: absolute;
    top: 0;
    left: 0;
    vertical-align: center;
    border: 1px dashed var(--v-n3-base);
    background-color: var(--v-white-base);
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;
    transition: all 0.3s ease-in-out;

    &:hover {
        border: 1px dashed var(--v-primary-base)
    }

    .v-icon {
        height: auto;
        width: auto;
    }
}

img:hover ~ .remove,
.remove:hover {
    visibility: visible;
}

.avatar {
    box-shadow: none;
    transition-property: box-shadow;
    transition-duration: 0.28s;
    transition-timing-function: map-get($transition, "fast-out-slow-in");

    &:hover {
        box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.26);
    }
}
</style>
